var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flash-message"},[_c('FlashMessage',{attrs:{"position":'top'}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }